<div>
  <p-selectButton
    [options]="viewOptions"
    [(ngModel)]="selectedView"
    (onChange)="viewChanged.emit(selectedView)"
    class="view-tabs-select-button"
  >
    <ng-template let-item>
      {{ item.label }}
      <span class="ui-badge" *ngIf="item.value === RiskManagementView.UnscheduledTasks">
        <span *ngIf="loadingCount"><i class="fa fa-spin fa-spinner"></i></span>
        <span *ngIf="!loadingCount && unscheduledCount != null">{{ unscheduledCount }}</span>
      </span>
    </ng-template>
  </p-selectButton>
</div>
